import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DropDown from "../atomic/DropDown";
import {
  resetDropdownValue,
  setDropdownValue,
  setFileValue,
  setHistoryId,
} from "../../slice/storage";
import toast, { Toaster } from 'react-hot-toast';
import { useToast } from '../Toast';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "./Modal";
import { fetchUserFiles } from "../../slice/apiSlice";
import constants, { BASE_URL } from "../constants";
import {
  addUserMessage,
  clearChatHistory,
  sendChatMessage,
} from "../../slice/chatSlice";
import { v4 as uuidV4 } from "uuid";
import { fetchTasksAsync } from "../../slice/taskSlice";
import { uploadFilesWithHistory, createChatHistory } from "../../Api/req";
import { getTaskStatusesByHistoryAsync } from '../../slice/taskStatusSlice';
import { selectAIProfile } from "../../slice/aiProfileSlice";
import { SlidersHorizontal } from "lucide-react";
import { 
  canStartTask, 
  recordTaskStarted, 
  canUploadPages,
  recordPagesUploaded
} from '../../utils/usageChecker';
import * as pdfjsLib from 'pdfjs-dist';

// Ensure pdfjs worker is set up for counting pages
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const list = [
  { id: "1232", task: "Invitation to tender" },
  { id: "2345", task: "Analaysis of the PDF" },
];

const ACCEPTED_FILE_TYPES = {
  "application/pdf": ".pdf",
  "application/msword": ".doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
};

const BUTTON_STATES = {
  disabled: {
    className: "bg-gray-300 cursor-not-allowed",
    hover: "",
  },
  enabled: {
    className: "bg-custom-yellow opacity-80",
    hover: "hover:bg-custom-yellow hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-custom-yellow",
  },
};

const ChatInput = ({
  taskID,
  taskName,
  project,
  historyId,
  onClick,
  searchType,
  prompt,
  toggleSearchSection,
  onHistoryCreated,
  chatName, // new prop
  setChatName, // new prop
  chatSettings, // ChatSettings prop
}) => {
  const notify = () => toast('Here is your toast.');
  const user_id = localStorage.getItem("id");
  const task_id = useSelector((state) => state.dropdown.id);
  const task_name = useSelector((state) => state.dropdown.task);
  const userFiles = useSelector((state) => state.api.userFiles);
  const location = useLocation();
  const dispatch = useDispatch();
  const selectedValue = useSelector((state) => state.dropdown.task);
  const aiProfile = useSelector(selectAIProfile);
  const [files, setFiles] = React.useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [isConverting, setIsConverting] = React.useState(false);
  const [error, setError] = React.useState(null);
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const userId = localStorage.getItem("id");
  const tasks = useSelector((state) => state.tasks.tasks);
  const { addToast, ToastContainer } = useToast();
  const [history_name, setHistoryName] = useState('');
  const { chatHistory = [], status, error1 } = useSelector((state) => state.history);
  const [showSearchSection, setShowSearchSection] = useState(false);
  const hname = chatHistory?.history_records;
  const [chatInput, setChatInput] = useState("");
  const { historyId: urlHistoryId } = useParams();
  const [localHistoryId, setLocalHistoryId] = useState(historyId || urlHistoryId || "");
  const { data: userData } = useSelector((state) => state.admin);

  // Add this effect:
  useEffect(() => {
    if (historyId && historyId !== localHistoryId) {
      setLocalHistoryId(historyId);
    }
  }, [historyId]);

  // Page type helpers
  const isChatRoute = location.pathname.startsWith('/chat');
  const isAnalysisRoute = location.pathname.startsWith('/analysis');
  const isRoot = location.pathname === '/';
  const isActiveAnalysisSession = isAnalysisRoute && Boolean(urlHistoryId);
  const isLandingAnalysis = (isAnalysisRoute && !urlHistoryId) || isRoot;

  // Show different UI components based on page type
  const showAnalysisSetup = isLandingAnalysis;
  const showChatInput = isChatRoute || isActiveAnalysisSession;

  // Format tasks for dropdown
  const CHAT_TASK_ID = "40";
  const formattedTasks = tasks
    .filter(task => task.id.toString() !== CHAT_TASK_ID)
    .map((task) => ({
      id: task.id.toString(),
      task: task.name,
    }));

  const handleToggleSearchSection = () => {
    setShowSearchSection(prev => !prev);
    toggleSearchSection();
  };

  useEffect(() => {
    if (historyId) {
      dispatch(getTaskStatusesByHistoryAsync(historyId));
    }
  }, [historyId, dispatch]);

  useEffect(() => {
    const userEmail = localStorage.getItem('email');
    dispatch(fetchTasksAsync(userEmail));
  }, [dispatch]);

  useEffect(() => {
    if (prompt) {
      if (typeof prompt === 'object' && prompt.description) {
        const questionTitle = prompt.title || null;
        handleSendMessage(prompt.description, questionTitle);
      } else if (typeof prompt === 'string') {
        handleSendMessage(prompt, null);
      }
    }
  }, [prompt]);

  const getChatSettingsValue = (key, fallback) => {
    if (taskID === '40' && chatSettings && chatSettings[key] !== undefined && chatSettings[key] !== null) {
      return chatSettings[key];
    }
    return fallback;
  };

  const handleSendMessage = async (message, title = null) => {
    const messageStr = typeof message === 'string' ? message : '';
    if (messageStr.trim() === "") return;

    setChatInput("");
    let textarea = document.getElementById("prompt");
    if (textarea) {
      textarea.style.height = "40px";
    }

    let currentHistoryId = localHistoryId;
    let currentTaskId = taskID;

    

    // Ensure task_id is '40' for chat page
    if (location.pathname.startsWith('/chat')) {
      currentTaskId = '40';
    }

          if (!localHistoryId) {
        try {
          // Get user's organization ID from admin state
          const organizationId = userData?.organization_id;
          
          if (!organizationId) {
            toast.error("User is not associated with any organization");
            return;
          }
          
          // Check task usage before creating history
          const taskCheck = await canStartTask(dispatch, organizationId, currentTaskId);
          
          if (!taskCheck.canProceed) {
            toast.error(taskCheck.error);
            return;
          }
          
          const newHistoryId = uuidV4();
          const result = await createChatHistory(
            userId,
            currentTaskId,
            newHistoryId,
            "",
            chatName || "",
            currentTaskId === '40' ? 'chat' : 'analyse'
          );
          currentHistoryId = result.history_id;
          currentTaskId = result.task_id || currentTaskId; // fallback to '40' if backend returns null
          setLocalHistoryId(currentHistoryId);
          if (typeof onHistoryCreated === "function") {
            onHistoryCreated(currentHistoryId, currentTaskId);
          }
          
          // Record task usage after successful creation
          await recordTaskStarted(dispatch, organizationId, currentTaskId);
        } catch (error) {
        let msg = "Ein Fehler ist aufgetreten.";
        if (error?.response?.data?.detail) {
          msg = error.response.data.detail;
        } else if (error?.message) {
          msg = error.message;
        }
        if (Array.isArray(msg)) {
          msg = msg.map(e => e.msg || e).join(" ");
        }
        toast.error(msg);
        return;
      }
    }

    dispatch(
      addUserMessage({
        content: messageStr,
        role: "user",
        title: title || ""
      })
    );

    // --- Unified logic for both chat and analysis ---
    let payload = {
      prompt: messageStr,
      user_id: userId,
      role: "user",
      assistant_role: "bot",
      search_type: searchType,
      temperature: getChatSettingsValue('temperature', aiProfile?.temperature),
      top_p: getChatSettingsValue('topp', aiProfile?.topp),
      system_prompt: getChatSettingsValue('system_prompt', aiProfile?.description),
      num_contexts: getChatSettingsValue('num_contexts', undefined),
      title: title || "",
      comment: "",
      history_id: currentHistoryId,
      task_id: currentTaskId,
    };
    dispatch(
      sendChatMessage(payload)
    );
    
    textarea = document.getElementById("prompt");
    if (textarea) {
      textarea.style.height = "40px";
    }
  };

  // When a new history is created (in handleSendMessage and handleUpload), setLocalHistoryId is already called.
  // Update the useEffect for fetching files to always use the latest localHistoryId (and only fetch if it exists):
  useEffect(() => {
    if (userId && localHistoryId) {
      dispatch(fetchUserFiles({ userId, taskId: localHistoryId }));
    }
  }, [userId, localHistoryId, dispatch]);

  const handleSelect = (value) => {
    dispatch(setDropdownValue(value));
  };

  const handleFileClick = () => {
    fileInputRef.current?.click();
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleYes = () => {
    closeModal();
    dispatch(clearChatHistory());
    // Check if user has "No License" role
    if (userData?.user_role === 'No License') {
      navigate('/hilfe');
      return;
    }
    navigate(`/`);
  };

  const handleNo = () => {
    closeModal();
  };

  const validateFile = (file) => {
    if (!file) return { isValid: false, error: "No file selected" };

    const isValidType = Object.keys(ACCEPTED_FILE_TYPES).includes(file.type);
    if (!isValidType) {
      return {
        isValid: false,
        error: `Please select only ${Object.values(ACCEPTED_FILE_TYPES).join(", ")} files`,
      };
    }

    return { isValid: true, error: null };
  };

  const handleFileChange = async (event) => {
    const newFiles = Array.from(event.target.files || []);
    setIsProcessing(true);
    setError(null);

    const validFiles = [];

    for (const file of newFiles) {
      const { isValid, error } = validateFile(file);
      if (isValid) {
        if (file.type === 'application/pdf') {
          try {
            const arrayBuffer = await file.arrayBuffer();
            const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
            file._pageCount = pdf.numPages; // Attach page count
            await pdf.destroy();
          } catch (e) {
            toast.error(`Error processing ${file.name}: Invalid PDF file`);
            continue;
          }
        } else if (file.type.includes('word')) {
            setIsConverting(true);
            const formData = new FormData();
            formData.append('file', file);
            try {
                const response = await fetch(`${BASE_URL}/convert-and-count`, {
                    method: 'POST',
                    body: formData,
                });
                const data = await response.json();
                if (response.ok) {
                    file._pageCount = data.page_count;
                } else {
                    toast.error(data.error || 'Failed to convert file');
                    continue;
                }
            } catch (e) {
                toast.error('Failed to convert file');
                continue;
            } finally {
                setIsConverting(false);
            }
        } else {
          file._pageCount = 0;
        }
        validFiles.push(file);
      } else {
        alert(`Error for ${file.name}: ${error}`);
      }
    }

    // Before accepting files when starting analysis (no active session), enforce page limits
    const isActiveAnalysisSession = isAnalysisRoute && Boolean(urlHistoryId);
    if (!isActiveAnalysisSession) {
      // Total pages in selected PDFs
      const totalPages = validFiles.reduce((acc, f) => acc + (f._pageCount || 0), 0);
      if (totalPages > 0) {
        const organizationId = userData?.organization_id;
        const currentTaskId = task_id || taskID || '40';
        try {
          const pageCheck = await canUploadPages(
            dispatch,
            organizationId,
            localHistoryId || urlHistoryId || 'temp',
            totalPages,
            currentTaskId
          );
          if (!pageCheck.canProceed) {
            toast.error(pageCheck.error || 'Upload exceeds available pages');
            setIsProcessing(false);
            return;
          }
        } catch (e) {
          // Fallback: block on error
          toast.error('Failed to verify page limits');
          setIsProcessing(false);
          return;
        }
      }
      setFiles(validFiles.slice(0, 1));
      
      if (newFiles.length > 1) {
        toast("Nur eine Datei ist für die erste Analyse zulässig.", {
          icon: 'ℹ️',
          duration: 3000,
          style: {
            background: '#333',
            color: '#fff',
          },
        });
      }
    } else {
      // Active session: just append; Sidebar flow already enforces blocking during actual upload
      setFiles((prevFiles) => [...prevFiles, ...validFiles]);
    }
    
    setIsProcessing(false);
  };

  const handleUpload = async () => {
    if ((isFileRequired && !files.length) || !userId) return;

    // Use the existing historyId if available
    let currentHistoryId = localHistoryId || urlHistoryId;

    try {
      setIsProcessing(true);

      // Only create a new chat history if there is NO historyId at all
      if (!currentHistoryId) {
        // Get user's organization ID from admin state
        const organizationId = userData?.organization_id;
        
        if (!organizationId) {
          toast.error("User is not associated with any organization");
          setIsProcessing(false);
          return;
        }
        
        // Check task usage before creating history
        const taskCheck = await canStartTask(dispatch, organizationId, task_id || taskID || "40");
        
        if (!taskCheck.canProceed) {
          toast.error(taskCheck.error);
          setIsProcessing(false);
          return;
        }
        
        currentHistoryId = uuidV4();
        const chatHistoryResult = await createChatHistory(
          userId,
          task_id || taskID || "40",
          currentHistoryId,
          task_name || taskName || "",
          history_name || "",
          location.pathname === '/chat' ? 'chat' : 'analyse'
        );
        
        setLocalHistoryId(currentHistoryId); // Store for future use
        setTimeout(() => {
          dispatch(fetchUserFiles({ userId, taskId: currentHistoryId }));
        }, 0);
        console.log("Chat history created:", chatHistoryResult);
        
        // Record task usage after successful creation
        await recordTaskStarted(dispatch, organizationId, task_id || taskID || "40");
      }

      // Before upload, enforce pages limit when starting analysis from main page
      const organizationId = userData?.organization_id;
      const currentTaskIdForUpload = task_id || taskID || "40";
      if (files.length > 0) {
        const totalPages = files.reduce((acc, f) => acc + (f._pageCount || 0), 0);
        if (totalPages > 0) {
          const pageCheck = await canUploadPages(
            dispatch,
            organizationId,
            currentHistoryId || 'temp',
            totalPages,
            currentTaskIdForUpload
          );
          if (!pageCheck.canProceed) {
            toast.error(pageCheck.error || 'Upload exceeds available pages');
            setIsProcessing(false);
            return;
          }
        }
      }

      // Always use the existing historyId for file upload
      if (files.length > 0) {
        const page_counts = files.map(f => f._pageCount || 0);
        const uploadResult = await uploadFilesWithHistory(
          files,
          userId,
          currentTaskIdForUpload,
          currentHistoryId,
          page_counts
        );
        console.log("Upload success:", uploadResult);

        // After successful upload, decrement available_pages
        const totalPages = files.reduce((acc, f) => acc + (f._pageCount || 0), 0);
        if (totalPages > 0) {
          const recorded = await recordPagesUploaded(
            dispatch,
            organizationId,
            currentHistoryId,
            totalPages,
            currentTaskIdForUpload
          );
          if (!recorded) {
            console.warn('[ChatInput][handleUpload] Failed to record page usage');
          }
        }

        setFiles([]);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }

      // Optionally navigate if you want to show the analysis page for the new chat
      if (!urlHistoryId && !localHistoryId) {
        // Check if user has "No License" role
        if (userData?.user_role === 'No License') {
          navigate('/hilfe');
          return;
        }
        navigate(`/analysis/${currentHistoryId}`);
      }
    } catch (error) {
      setIsProcessing(false);
      let msg = "Ein Fehler ist aufgetreten.";
      if (error?.response?.data?.detail) {
        msg = error.response.data.detail;
      } else if (error?.message) {
        msg = error.message;
      }
      if (Array.isArray(msg)) {
        msg = msg.map(e => e.msg || e).join(" ");
      }
      toast.error(msg);
      return;
    } finally {
      setIsProcessing(false);
    }
  };

  const selectedTaskId = task_id ? task_id : taskID;
  const selectedTask = tasks.find(t => t.id.toString() === selectedTaskId?.toString());
  const fileUploadRequired = selectedTask?.file_upload_required;
  const isFileRequired = fileUploadRequired === true || fileUploadRequired === 1;
  const isChatPage = location.pathname === "/chat";
  const isSubmitEnabled = isChatPage
    ? !isProcessing
    : (selectedValue || taskName) &&
      (!isFileRequired || files.length > 0) &&
      !isProcessing &&
      (history_name || urlHistoryId);

  const getButtonStyles = (isEnabled) => {
    const state = isEnabled ? BUTTON_STATES.enabled : BUTTON_STATES.disabled;
    return `${state.className} ${state.hover}`;
  };

  const handleRemoveFile = (indexToRemove) => {
    setFiles((prevFiles) => {
      const newFiles = prevFiles.filter((_, index) => index !== indexToRemove);
      return newFiles;
    });
  };

  return (
    <footer className="bg-white flex justify-center items-center">
      <Toaster position="top-right"/>
      <div className="flex-1 max-w-4xl">
        <div className="bg-white w-full rounded-lg shadow-lg">

          <div className="flex items-center gap-4 border-b pb-3 pl-3 w-full justify-between">
            <div className="flex items-center gap-3 w-full justify-between">
              {isChatRoute && (
                null
              )}
              {(showAnalysisSetup || isActiveAnalysisSession) && (
                <div className={`flex items-center gap-3 text-white ${!selectedValue && !taskName ? 'w-[300px]' : 'w-full'}`}>
                  <DropDown
                    list={formattedTasks}
                    onSelect={handleSelect}
                    selectedValue={taskName ? taskName : selectedValue}
                    disabled={isActiveAnalysisSession}
                  />
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept={Object.values(ACCEPTED_FILE_TYPES).join(",")}
                    style={{ display: "none" }}
                    multiple={isActiveAnalysisSession}
                  />
                  {(selectedValue || taskName) && <img className="w-4 h-4" src={constants.arrow}/>}
                  {(selectedValue || taskName) && (
                    <div className="flex flex-col w-full gap-2">
                      <input
                        type="text"
                        onChange={(e) => setHistoryName(e.target.value)}
                        className="w-full px-3 py-3 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white"
                        placeholder="Projekt benennen"
                        disabled={isActiveAnalysisSession || (!selectedValue && !taskName)}
                        value={isActiveAnalysisSession ? hname?.history_name : history_name}
                        readOnly={isActiveAnalysisSession}
                      />
                    </div>
                  )}
                  {/* Add second arrow before upload button, only before task is started */}
                  {(selectedValue || taskName) && !isActiveAnalysisSession && (
                    <img className="w-4 h-4" src={constants.arrow} />
                  )}
                  {(selectedValue || taskName) && !isActiveAnalysisSession && (
                    <button
                      type="button"
                      onClick={handleFileClick}
                      className={`inline-flex items-center justify-center px-3 py-2.5 w-full border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white ${
                        selectedValue || taskName ? "hover:bg-gray-50" : "opacity-50 cursor-not-allowed"
                      }`}
                      disabled={!selectedValue && !taskName}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mr-2"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                        />
                      </svg>
                      {isConverting ? "Zu PDF konvertieren..." : isProcessing ? "Verarbeiten..." : "Dateien hinzufügen"}
                    </button>
                  )}
                </div>
              )}
              <div>
                {isActiveAnalysisSession && (
                  <div className="flex ml-auto gap-2 pr-5">
                    <div className="relative group w-full">
                      <button
                        type="button"
                        className="inline-flex gap-2 items-center px-3 py-2 text-sm leading-4 font-medium rounded-md text-custom-gray bg-white opacity-90"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7 20V18H17V20H7Z"
                            fill="#5F6368"
                            fillOpacity="0.8"
                          />
                          <path
                            d="M13 12.175L13 4L11 4L11 12.175L8.4 9.6L7 11L12 16L17 11L15.6 9.6L13 12.175Z"
                            fill="#5F6368"
                            fillOpacity="0.8"
                          />
                        </svg>
                        Export
                      </button>
                      <div className="absolute right-50 mt-1 w-60 bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                        <div className="py-1">
                          <button
                            onClick={() => onClick(true)}
                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          >
                            Export mit Kommentaren
                          </button>
                          <button
                            onClick={() => onClick(false)}
                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          >
                            Export ohne Kommentare
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* File List Display - place this above the button */}
          {files.length > 0 && (
            <div className="mt-2 px-4">
              <p className="text-sm text-gray-500">Ausgewählte Dateien:</p>
              {files.map((file, index) => (
                <li
                  key={index}
                  className="flex items-center justify-between text-sm bg-gray-50 p-2 rounded"
                >
                  <div className="flex items-center">
                    <svg
                      className="mr-2 h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                      <polyline points="14 2 14 8 20 8" />
                    </svg>
                    {file.name}
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveFile(index);
                    }}
                    className="text-gray-500 hover:text-red-500 p-1"
                    aria-label="Remove file"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </button>
                </li>
              ))}
            </div>
          )}

          {/* Analysis Setup Section - Only for landing/analysis pages */}
          {showAnalysisSetup && (history_name || (hname && hname.history_name)) && (
            <div className="flex align-center justify-center w-full">
              <button
                type="button"
                onClick={handleUpload}
                className={`inline-flex justify-center items-center mt-3 mb-3 px-20 py-2 border border-transparent rounded-md shadow-sm text-white ${getButtonStyles(isSubmitEnabled)}`}
                disabled={!isSubmitEnabled}
              >
                {isProcessing ? "Hochladen..." : "Analyse starten"}
              </button>
            </div>
          )}

          {/* Chat Input Section - Only for chat pages and active analysis sessions */}
          {showChatInput && (
            <div className="p-2 flex items-center">
              <div className="flex items-center w-full">
                <textarea
                  type="text"
                  name="prompt"
                  id="prompt"
                  value={chatInput}
                  className={`block w-full sm:text-sm rounded-md resize-none p-2 border border-gray-300 focus:outline-none ${isChatRoute ? 'opacity-50 cursor-not-allowed' : ''}`}
                  style={{
                    minHeight: "40px",
                    maxHeight: "150px",
                    overflowY: "auto"
                  }}
                  placeholder={isChatRoute ? "Chat ist deaktiviert" : "Prompt eingeben"}
                  onChange={(e) => setChatInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleSendMessage(chatInput, null);
                      e.target.style.height = "40px";
                    }
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto";
                    e.target.style.height = Math.min(e.target.scrollHeight, 150) + "px";
                  }}
                  disabled={isChatRoute}
                />
                <button
                  onClick={() => handleSendMessage(chatInput, null)}
                  type="button"
                  disabled={isChatRoute}
                  className={`ml-3 inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-custom-yellow ${isChatRoute ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 10l7-7m0 0l7 7m-7-7v18"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )}

          <Modal
            isOpen={isModalOpen}
            onClose={closeModal}
            onYes={handleYes}
            onNo={handleNo}
            title="Neue Analyse?"
          >
            <ToastContainer/>
            <p>
              Sind Sie sicher, dass Sie die aktuelle Analyse schliessen und
              eine neue starten möchten?
            </p>
          </Modal>
        </div>
      </div>
    </footer>
  );
};

export default ChatInput;